module.exports = __webpack_public_path__ + "img/comment-xmark.cbf26677.svg";